import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';

import { TopicModel, ProblemModel } from '@generativ/much-smarter-models';
import { ExerciseService } from '../../exercise.service';
import { MultiChoiceComponent } from '../../exercise-problem/multi-choice/multi-choice.component';
import { UtilitiesService } from '../../../../shared/utilities.service';
import { Subscription } from 'rxjs';
import { ContentViewerComponent } from '../../../../shared/content-viewer/content-viewer.component';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap/tooltip';

@Component({
    selector: 'app-lesson-strategy-identification',
    templateUrl: './exercise-strategy-identification.component.html',
    styleUrls: ['../exercise-strategy.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ContentViewerComponent, MultiChoiceComponent, NgbTooltip, RouterLink]
})
export class ExerciseStrategyIdentificationComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  strategyTopics: TopicModel[];
  strategyProblem: ProblemModel;

  readyToContinue = false;

  @ViewChild(MultiChoiceComponent, { static: true })
  private multiChoiceComponent: MultiChoiceComponent<TopicModel>;

  constructor(private activatedRoute: ActivatedRoute,
              private utilitiesService: UtilitiesService,
              private exerciseService: ExerciseService) {
  }

  ngOnInit() {
    this.strategyProblem = this.exerciseService.getStrategyProblem();
    this.strategyTopics = this.exerciseService.getStrategyTopics();
  }

  ngOnDestroy(): void {
  }

  handleSelectedTopic() {
    this.subscriptions.add(this.exerciseService.identifyTopicForExercise(this.strategyProblem.id).subscribe(data => {
      this.readyToContinue = true;
      this.multiChoiceComponent.setRightOption(+data);
    }));
  }
}
